import React, { useState, useEffect } from "react";
import RatingGamePhonics from "../../components/RatingGamePhonics";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
//Mixes up array
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

export default function Rating({ ...props }) {
    const game = useGame(props.game.id);
    const { questions } = useRatingQuestions({ game_type: game.game_type }, game);

    let formattedQuestions = questions ? questions.map(qs=>qs.map(q=>{
        console.log(q);
        let answers = [
            {value: q.right_answer, correct: true, audio: q.audio},
            {value: q.wrong_answer_1, correct: false, audio: q.wrong_answer_1}
        ];
        shuffleArray(answers);
        return {
            question: q.right_answer,
            answers,
            topic_id: q.topic_id
        };
    })) : null;

    return formattedQuestions ? (
        <RatingGamePhonics
            questionslist={formattedQuestions}
            playAudio={true}
            onBack={() => {
                navigate(`/games/${game.id}`);
            }}
            game={game}
            endless={props.endless}
            initialLevel={props.initialLevel}
        />
    ) : (
        <LoadingScreen />
    );
}
